<div class="map-popup-header flex" style="width: 100%">
  <div class="map-popup-title">
    <b>{{ 'VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER' | translate }}</b>
  </div>
</div>
@if (!isDownloaded()) {
  <table class="map-popup-table">
    <tr>
      <td class="map-popup-cell-text-linebreak">{{ fastighetGeometri?.attributes?.kommunnamn }}</td>
      <td class="map-popup-cell-text-linebreak">{{ fastighetGeometri?.attributes?.trakt }}</td>
      <td class="map-popup-cell-text-linebreak map-popup-cell-number">{{ fastighetGeometri?.attributes?.blockenhet }}</td>
      <td class="map-popup-cell-text-linebreak map-popup-cell-number">{{ fastighetGeometri?.attributes?.omrnr }}</td>
    </tr>
  </table>
}
@if (isDownloaded()) {
  <table class="map-popup-table">
    <tr>
      <td class="map-popup-cell-text-linebreak">{{ fastighetMetria.kommun }}</td>
      <td class="map-popup-cell-text-linebreak">{{ fastighetMetria.trakt }}</td>
      <td class="map-popup-cell-text-linebreak map-popup-cell-number">{{ fastighetMetria.block }} {{ fastighetMetria.tecken }} {{ fastighetMetria.enhet }}</td>
    </tr>
  </table>
}

<div class="map-popup-fastighetsagare">
  @for (agare of getFastighetsagare(5); track agare) {
    <div>
      <div><a [href]="getExtUrlSearch(agare)" target="_blank">{{ getFastighetsagareNamn(agare) }} (sök på eniro)<i class="fa-solid fa-arrow-up-right-from-square"></i></a></div>
      <div class="map-popup-adress-container">
        <div class="map-popup-adress">{{ getAdress1(agare) }}</div><div class="map-popup-orgnr">{{ agare.personOrgNummer }} @if (existsInRask(agare.personOrgNummer)) {
        <b>*</b>
      }</div>
    </div>
    <hr class="map-popup-divider">
  </div>
}
@if (hasMoreAgareThan(5)) {
  <div>
    <td colspan="4"><i>Det finns fler ägare.</i></td>
  </div>
}
</div>

<div class="right mt-2 mb-2">
  @if (!isDownloaded()) {
    <rask-button class="menu-btn neutral" color="tertiary" (click)="downloadFromMetria()">
    {{ 'VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_HAMTA' | translate }}</rask-button>
  }
  @if (isDownloaded()) {
    <rask-button class="menu-btn neutral" color="tertiary" (click)="copyToClipboard()">Kopiera till urklipp</rask-button>
  }
  @if (isDownloaded() && showImportOption()) {
    <rask-button class="menu-btn neutral" color="primary" [disabled]="!hasMoreAgareThan(0)" (click)="clickImportLeverantor()">Importera leverantör(er)</rask-button>
  }
</div>